/* Bedtextielonline (Claude): productpagina compacter, vooral op de gsm.
   - Overal: 'Hulp bij je maat' wordt een klein knopje 'Welke maat?' naast 'Afmeting' (opent dezelfde maatgids).
   - Hoekhoogte: rustig infolabel 'Past op matrassen tot ± 35 cm dik', onder de rij 'Hoekhoogte' (30 cm | 40 cm) als die er is,
     anders onder de maatknoppen met de hoekhoogte erbij.
   - Op gsm en computer dezelfde volgorde: het actieblok '2e dekbedovertrek'
     en 'Vaak gecombineerd met' onder de knop; de vinkjes (stof, instopstrook, wassen ...) net onder het
     vertrouwensblok (levering, gratis verzending, retour).
   Wordt geladen vanuit snippets/btol-pdp-vinkjes.liquid. */
(function () {
  if (window.__btolPdpGsm) return;
  window.__btolPdpGsm = true;
  var btolT = function (k, d, v, ruw) { var s = (window.BTOL_T && window.BTOL_T[k]) || d; if (!ruw && !/_html$/.test(k)) s = String(s).replace(/&(#39|#x27|quot|lt|gt|amp);/g, function (m, e) { return { '#39': "'", '#x27': "'", quot: '"', lt: '<', gt: '>', amp: '&' }[e]; }); if (v) Object.keys(v).forEach(function (n) { s = String(s).split('{' + n + '}').join(v[n]); }); return s; };

  var st = document.createElement('style');
  st.textContent =
    /* maathulp: groot veld weg, knopje naast 'Afmeting' */
    '.product-info__block-item:has(> .liquid > .btol-mh){margin:0!important}' +
    '.btol-mh.btol-mh--klein{display:none!important}' +
    '.btol-mh-legend{display:flex!important;align-items:center;justify-content:space-between;gap:10px;width:100%}' +
    '.btol-mh-tip{white-space:nowrap;flex:0 0 auto;display:inline-flex;align-items:center;gap:6px;min-height:32px;padding:0 12px 0 10px;border:0;border-radius:999px;background:#EEF0FA;color:#2F2A44;font:inherit;font-size:13.5px;font-weight:600;letter-spacing:0;text-transform:none;cursor:pointer;transition:background-color .15s ease}' +
    '.btol-mh-tip svg{width:16px;height:16px;flex:0 0 16px}' +
    '@media (hover:hover){.btol-mh-tip:hover{background:#DADDFB}}' +
    '.btol-mh-legend > span:first-child{flex:1 1 auto}' +
    /* hoekhoogte: rustig infolabel, onder de rij 'Hoekhoogte' (of onder 'Maat' als die rij er niet is) */
    '.btol-mh-hoek{display:inline-flex!important;align-items:center;gap:8px;justify-self:start;align-self:flex-start;width:auto!important;max-width:100%;margin:4px 0 0!important;padding:7px 12px 7px 10px;border-radius:12px;background:#F6F5F3;color:#2F2A44!important;font-size:14px!important;font-weight:400!important;line-height:1.35!important;letter-spacing:0!important;text-transform:none!important}' +
    '.btol-mh-hoek svg{flex:0 0 18px;width:18px;height:18px;color:#2F2A44}' +
    '.btol-mh-hoek strong{font-weight:700}' +
    /* volgorde in de productinfo (gsm en computer gelijk) */
      '.product-info__block-list{display:flex;flex-direction:column}' +
      '.product-info__block-list > *{margin-bottom:0!important}' +
      '.product-info__block-list > .btol-a2{order:1}' +
      '.product-info__block-list > [data-block-type="complementary-products"]{order:2}' +
      /* merk-pil zonder logo: tekst mooi in het midden, zelfde maat als de stof-pil */
      '.product-info .badge.badge--merk:not(:has(img)){padding:5px 11px!important;gap:0;line-height:1.2}' +
      /* 'Maak je bed compleet' (aanvullende producten): overal dezelfde ruimte, knop binnen de kaart */
      '.btol-ups.complementary-products{gap:0!important;padding:16px!important}' +
      '.btol-ups .btol-ups__titel{margin:0 0 12px!important}' +
      '.btol-ups .btol-upsell-wrap{padding:12px!important}' +
      '.btol-ups .btol-upsell-card{padding:0!important;gap:14px!important}' +
      '.btol-ups .btol-upsell-card .button{width:100%!important;max-width:100%;box-sizing:border-box}' +
      /* merk: één keer, als rustige tekst boven de titel (geen merk-pil meer tussen de badges) */
      '.product-info .badge.badge--merk{display:none!important}' +
      '.product-info [data-block-type="vendor"]{margin-top:14px!important;margin-bottom:-2px!important}' +
      '.product-info .btol-pdp-merk{display:inline-block;font-size:13px!important;font-weight:700!important;letter-spacing:.09em!important;text-transform:uppercase!important;color:rgba(47,42,68,.62)!important;text-decoration:none!important;transition:color .15s ease}' +
      '@media (hover:hover){.product-info a.btol-pdp-merk:hover{color:#2F2A44!important;text-decoration:underline!important;text-underline-offset:3px}}';
  document.head.appendChild(st);

  var LAT = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 15.5 15.5 3 21 8.5 8.5 21z"/><path d="m7 12 1.5 1.5M10 9l2 2M13 6l1.5 1.5"/></svg>';

  function maatVeld() {
    var vp = document.querySelector('variant-picker[context="main_product"]') || document.querySelector('.product-info variant-picker');
    if (!vp) return null;
    var sets = vp.querySelectorAll('fieldset');
    for (var i = 0; i < sets.length; i++) {
      var lg = sets[i].querySelector('legend');
      if (lg && /maat|afmeting|size|dimension|taille/i.test(lg.textContent)) return sets[i];
    }
    return null;
  }

  function maathulp() {
    var groot = document.querySelector('.btol-mh[data-btol-maatgids-open]');
    var veld = maatVeld();
    if (!groot || !veld) return;
    var lg = veld.querySelector('legend');
    if (lg.querySelector('.btol-mh-tip')) { hoekInfo(groot, lg); return; }
    groot.classList.add('btol-mh--klein');
    var label = document.createElement('span');
    while (lg.firstChild) label.appendChild(lg.firstChild);
    lg.appendChild(label);
    lg.classList.add('btol-mh-legend');
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'btol-mh-tip';
    b.setAttribute('data-btol-maatgids-open', groot.getAttribute('data-btol-maatgids-open'));
    b.setAttribute('aria-haspopup', 'dialog');
    b.innerHTML = LAT + '<span>' + btolT('welke_maat', 'Welke maat?', null, true) + '</span>';
    lg.appendChild(b);
    hoekInfo(groot, lg);
  }

  /* 'Hoekhoogte 40 cm · past op matrassen tot ± 35 cm dik' als rustig infolabel */
  var MATRAS = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="9" width="18" height="7" rx="2"/><path d="M12 4v4M10 6l2-2 2 2M12 21v-4M10 19l2 2 2-2"/></svg>';
  function hoekInfo(groot, lg) {
    if (document.querySelector('.btol-mh-hoek')) return;
    var bron = Array.prototype.filter.call(groot.querySelectorAll('small'), function (s) { return /hoekhoogte|bonnet/i.test(s.textContent); })[0];
    if (!bron) return;
    var getallen = bron.textContent.match(/(\d+)\s*cm/g) || [];
    var hoek = getallen[0] ? parseInt(getallen[0], 10) : 0, matras = getallen[1] ? parseInt(getallen[1], 10) : 0;
    if (!hoek || !matras) return;
    var p = document.createElement('p');
    p.className = 'btol-mh-hoek';
    /* staat er een rij 'Hoekhoogte' (gekoppelde producten), dan komt de uitleg daaronder */
    var rij = null;
    document.querySelectorAll('.product-siblings .variant-picker__option').forEach(function (o) {
      var t = o.querySelector('.text-subdued');
      if (t && /hoekhoogte|bonnet/i.test(t.textContent)) rij = o;
    });
    if (rij) {
      p.innerHTML = MATRAS + '<span>' + btolT('hoek_past_html', 'Past op matrassen tot ± <strong>{matras} cm</strong> dik', { matras: matras }) + '</span>';
      rij.appendChild(p);
    } else {
      p.innerHTML = MATRAS + '<span>' + btolT('hoek_info_html', '<strong>Hoekhoogte {hoek} cm</strong> · past op matrassen tot ± {matras} cm dik', { hoek: hoek, matras: matras }) + '</span>';
      /* onder de maatknoppen, niet naast 'Maat' */
      var veld = lg.closest('fieldset') || lg.parentElement;
      veld.appendChild(p);
    }
  }

  /* vinkjes net onder het vertrouwensblok (levering, gratis verzending, retour ...), anders onder de koopknop */
  function vinkjes() {
    var lijst = document.querySelector('.product-info__block-list');
    if (!lijst) return;
    var v = lijst.querySelector(':scope > .product-info__block-item:has(> .liquid > .btol-vink)');
    var na = lijst.querySelector(':scope > .product-info__block-item:has(> .liquid > .btol-zeker), :scope > .product-info__block-item:has(.btol-zeker)') ||
      lijst.querySelector(':scope > [data-block-type="buy-buttons"]');
    if (!v || !na || na === v) return;
    if (na.nextElementSibling !== v) lijst.insertBefore(v, na.nextElementSibling);
  }

  function alles() { maathulp(); vinkjes(); }
  var wacht = null;
  function straks() { clearTimeout(wacht); wacht = setTimeout(alles, 40); }
  function start() {
    if (!document.querySelector('product-gallery')) return;
    alles();
    var info = document.querySelector('.product-info') || document.body;
    if (window.MutationObserver) new MutationObserver(function () {
      var v = maatVeld();
      if (v && !v.querySelector('.btol-mh-tip')) maathulp(); else straks();
    }).observe(info, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();